/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIResponseError
 */
export interface APIResponseError {
    /**
     * 
     * @type {number}
     * @memberof APIResponseError
     */
    httpcode?: number;
    /**
     * 
     * @type {string}
     * @memberof APIResponseError
     */
    message?: string;
}

/**
 * Check if a given object implements the APIResponseError interface.
 */
export function instanceOfAPIResponseError(value: object): value is APIResponseError {
    return true;
}

export function APIResponseErrorFromJSON(json: any): APIResponseError {
    return APIResponseErrorFromJSONTyped(json, false);
}

export function APIResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIResponseError {
    if (json == null) {
        return json;
    }
    return {
        
        'httpcode': json['httpcode'] == null ? undefined : json['httpcode'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function APIResponseErrorToJSON(json: any): APIResponseError {
    return APIResponseErrorToJSONTyped(json, false);
}

export function APIResponseErrorToJSONTyped(value?: APIResponseError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'httpcode': value['httpcode'],
        'message': value['message'],
    };
}

